import React, { useState, useRef } from "react";
import { useGetAgendaWithAssignmentQuery } from "../../../api/useGetAgendaWithAssignment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Input,
  TextareaAutosize,
  Popover,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
} from "@mui/material";

import PreviousAssignmentsRow from "./PreviousAssignmentsRow";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import styled from "@emotion/styled";
import EditableInputCell from "../../../common/components/EditableInputCell";
import { useUpdateAdminAssignmentQuery } from "../../../api/useUpdateAdminAssignment";
import { useQueryClient } from "@tanstack/react-query";
import EditableChipCell from "../../../common/components/EditableChipCell";
import StatusDashboard from "./StatusDashboard";
import { useCloseAssignmentQuery } from "./../../../api/useCloseAssignment";
import { truncateText } from "../../../utils/text";
import { useUpdateAssignmentToPassQuery } from "./../../../api/useUpdateAssignmentToPass";
import { useAuth } from "../../../context/AuthContext";
import AssignmentDialog from "../../AssignmentPage/components/AssignmentDialog";
import AdminAssignmentSubmitDialog from "./AdminAssignmentSubmitDialog";
import { useDeleteAssignmentByAdmin } from "../../../api/useDeleteAssignmentByAdmin";

export const StyledTableCell = styled(TableCell)(({ width }) => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: `${width}`,
  textOverflow: "ellipsis",
  userSelect: "text",
}));

export const StyledFeedbackCell = styled(TableCell)(({ width }) => ({
  width: `${width}`,
  whiteSpace: "normal",
  wordBreak: "break-word",
  userSelect: "text",
}));

const ensureHttps = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return "https://" + url;
};

// submission ??낆쓣 ?뺤씤?섎뒗 ?ы띁 ?⑥닔
const getSubmissionType = (submissionTitle, selectedAgenda) => {
  const submissionLink = selectedAgenda.submissionLinks.find(
    (link) => link.title === submissionTitle
  );
  return submissionLink?.type || "url";
};

// ?대?吏 誘몃━蹂닿린 而댄룷?뚰듃
const ImagePreview = ({ src, alt, onDoubleClick }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "60px",
      cursor: "pointer",
    }}
    onDoubleClick={onDoubleClick}
  >
    <Avatar
      src={src}
      alt={alt}
      variant="rounded"
      sx={{
        width: 50,
        height: 50,
        objectFit: "cover",
        border: "1px solid #ddd",
        "&:hover": {
          transform: "scale(1.05)",
          transition: "transform 0.2s",
        },
      }}
    />
  </Box>
);

const DetailAssignments = ({ selectedAgenda, onHandleBack }) => {
  const [isClosed, setIsClosed] = useState(selectedAgenda.isClosed || false);
  const { data, isLoading, isError, error } = useGetAgendaWithAssignmentQuery({
    agendaId: selectedAgenda._id,
  });

  const queryClient = useQueryClient();
  const {
    mutate: updateAssignment,
    isPending: isUpdateLoading,
    isError: isUpdateError,
    error: updateError,
  } = useUpdateAdminAssignmentQuery();

  const {
    mutate: closeAgenda,
    isPending: isCloseAgendaLoading,
    isError: isCloseAgendaError,
    error: closeAgendaError,
  } = useCloseAssignmentQuery();
  const { currentUser } = useAuth();
  const { mutate: updateAssignmentToPass, isLoading: isPassLoading } =
    useUpdateAssignmentToPassQuery();
  const { mutate: deleteAssignment, isLoading: isDeleteLoading } =
    useDeleteAssignmentByAdmin();
  const [errorMessage, setErrorMessage] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [popoverContent, setPopoverContent] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDetailsFor, setOpenDetailsFor] = useState(null);
  const [openAssignmentDialog, setOpenAssignmentDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const handleCellClick = (event, content) => {
    setAnchorEl(event.currentTarget);
    setPopoverContent(content);
    setOpenPopover(true);
  };

  const handlePopoverClose = () => {
    setOpenPopover(false);
  };

  const handleErrorDialogClose = () => {
    setIsErrorDialogOpen(false);
    setErrorMessage(null);
  };

  const handleFeedbackChange = (from, value, id) => {
    const data = { [from]: value, id: id };
    updateAssignment(data, {
      onSuccess: () => {
        setErrorMessage("");
        queryClient.invalidateQueries(["assignments", selectedAgenda?._id]);
      },
      onError: (error) => {
        setErrorMessage(error.response.data.error || "?섏젙???ㅽ뙣?덉뒿?덈떎.");
        setIsErrorDialogOpen(true);
      },
    });
  };
  const handleOpenPreviousAssignmentList = (studentId) => {
    setOpenDetailsFor((prev) => (prev === studentId ? null : studentId));
  };
  const handleCloseAssignment = () => {
    closeAgenda(
      { id: selectedAgenda._id },
      {
        onSuccess: () => {
          setIsClosed((prev) => !prev);
          queryClient.invalidateQueries(["assignments", selectedAgenda?._id]);
        },
        onError: (error) => {
          setErrorMessage(
            error.response.data.message || "留덇컧???ㅽ뙣?덉뒿?덈떎."
          );
          setIsErrorDialogOpen(true);
        },
      }
    );
  };

  const submitByAdmin = (userId) => {
    setSelectedUserId(userId);
    setOpenAssignmentDialog(true);
  };
  const handlePass = () => {
    if (!window.confirm("?뺣쭚 紐⑤몢 ?⑥뒪濡?諛붽씀?쒓쿋?듬땲源?")) return;
    const assignmentList = data.reduce((total, ass) => {
      if (!ass.assignment) return total;
      return [...total, ass.assignment[ass.assignment.length - 1]._id];
    }, []);

    updateAssignmentToPass(assignmentList, {
      onSuccess: () => {
        setErrorMessage("");
        queryClient.invalidateQueries([
          "admin-assignments",
          selectedAgenda._id,
        ]);
      },
      onError: (error) => {
        setErrorMessage(
          error.response.data.message || "?곹깭 ?섏젙???ㅽ뙣?덉뒿?덈떎"
        );
        setIsErrorDialogOpen(true);
      },
    });
  };

  const handleDelete = (assignmentId) => {
    if (!window.confirm("?뺣쭚 ??젣?섏떆寃좎뒿?덇퉴?")) return;
    deleteAssignment(
      { assignmentId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([
            "admin-assignments",
            selectedAgenda._id,
          ]);
        },
        onError: (error) => {
          setErrorMessage(error.response.data.message || "??젣???ㅽ뙣?덉뒿?덈떎");
          setIsErrorDialogOpen(true);
        },
      }
    );
  };
  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <div>
      <Dialog
        open={isErrorDialogOpen}
        onClose={handleErrorDialogClose}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
      >
        <DialogTitle id="error-dialog-title">?ㅻ쪟 諛쒖깮</DialogTitle>
        <DialogContent>
          <Typography>{errorMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrorDialogClose} color="primary" autoFocus>
            ?뺤씤
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          opacity: isErrorDialogOpen ? 0.5 : 1,
          pointerEvents: isErrorDialogOpen ? "none" : "auto",
        }}
      >
        <Box display="flex" alignItems="center" gap={2} mb={3}>
          <IconButton onClick={onHandleBack} aria-label="뒤로가기" size="large">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" gutterBottom>
            {selectedAgenda.assignment}
          </Typography>
          {currentUser.role === "admin" && (
            <>
              <Button
                variant="contained"
                color={isClosed ? "primary" : "error"}
                onClick={handleCloseAssignment}
                disabled={isCloseAgendaLoading}
              >
                {isCloseAgendaLoading
                  ? "Loading..."
                  : isClosed
                  ? "怨쇱젣 ?닿린"
                  : "留덇컧?섍린"}
              </Button>
              <Button color="success" variant="contained" onClick={handlePass}>
                紐⑤몢 ?⑥뒪濡?諛붽씀湲?              </Button>
            </>
          )}
        </Box>
        <StatusDashboard data={data} />
        <TableContainer
          component={Paper}
          sx={{
            marginBottom: 4,
            width: "100%",
          }}
        >
          <Table
            sx={{
              tableLayout: "fixed",
              width: "100%",
            }}
            aria-label="assignment-table"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell width="5%">no</StyledTableCell>
                <StyledTableCell width="7.14%">?대쫫</StyledTableCell>
                <StyledTableCell width="7.14%">이메일</StyledTableCell>
                {selectedAgenda.submissionLinks.map((submission) => (
                  <StyledTableCell width="7.29%">
                    {submission.title}
                  </StyledTableCell>
                ))}
                <StyledTableCell width="7.14%">?곹깭</StyledTableCell>
                <StyledTableCell width="16%">媛쒖꽑?ы빆</StyledTableCell>
                <StyledFeedbackCell width="20%">피드백</StyledFeedbackCell>
                {currentUser.role === "admin" && (
                  <StyledTableCell width="7.14%">??젣?섍린</StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((std, index) => (
                <>
                  <TableRow key={std.userId._id}>
                    <StyledTableCell width="7.14%">{index + 1}</StyledTableCell>
                    <StyledTableCell
                      width="14.29%"
                      onClick={() =>
                        handleOpenPreviousAssignmentList(std.userId._id)
                      }
                    >
                      {std.userId.name}
                    </StyledTableCell>
                    <StyledTableCell width="7.14%">
                      {std.userId.email}
                    </StyledTableCell>
                    {std.assignment
                      ? std.assignment[
                          std.assignment.length - 1
                        ].submissionLinks.map((submission, submissionIndex) => {
                          const submissionType = getSubmissionType(
                            submission.title,
                            selectedAgenda
                          );

                          return (
                            <StyledTableCell
                              key={submissionIndex}
                              width="14.29%"
                            >
                              {submissionType === "image" && submission.link ? (
                                <ImagePreview
                                  src={submission.link}
                                  alt={submission.title}
                                  onDoubleClick={() => {
                                    window.open(ensureHttps(submission.link), "_blank");
                                  }}
                                />
                              ) : (
                                <Input
                                  sx={{ width: "100%" }}
                                  readOnly
                                  value={submission.link}
                                  onClick={(e) => {
                                    e.currentTarget.focus();
                                  }}
                                  onDoubleClick={() => {
                                    window.open(ensureHttps(submission.link), "_blank");
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      (e.ctrlKey || e.metaKey) &&
                                      e.code === "KeyC"
                                    ) {
                                      navigator.clipboard
                                        .writeText(submission.link)
                                        .then(() => {});
                                    }
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </StyledTableCell>
                          );
                        })
                      : selectedAgenda.submissionLinks.map((_, emptyIndex) => (
                          <StyledTableCell key={emptyIndex} width="14.29%">
                            -
                          </StyledTableCell>
                        ))}

                    {std.assignment ? (
                      <>
                        <EditableChipCell
                          name="state"
                          value={
                            std.assignment[std.assignment.length - 1].state
                          }
                          id={std.assignment[std.assignment.length - 1]._id}
                          onChange={handleFeedbackChange}
                        />
                        <StyledTableCell
                          width="14.29%"
                          onClick={(e) =>
                            handleCellClick(
                              e,
                              std.assignment
                                ? std.assignment[std.assignment.length - 1]
                                    .message
                                : ""
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          {std.assignment
                            ? truncateText(
                                std.assignment[std.assignment.length - 1]
                                  .message,
                                20
                              )
                            : ""}
                        </StyledTableCell>

                        <EditableInputCell
                          id={std.assignment[std.assignment.length - 1]._id}
                          value={
                            std.assignment[std.assignment.length - 1].feedback
                          }
                          onChange={handleFeedbackChange}
                          name="feedback"
                          style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        />
                        {currentUser.role === "admin" && (
                          <TableCell>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              disabled={isDeleteLoading}
                              onClick={() =>
                                handleDelete(
                                  std.assignment[std.assignment.length - 1]._id
                                )
                              }
                            >
                              ??젣
                            </Button>
                          </TableCell>
                        )}
                      </>
                    ) : (
                      <TableCell width="14.29%">
                        誘몄젣異?                        {currentUser.role === "admin" ? (
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={() => submitByAdmin(std.userId._id)}
                          >
                            ?쒖텧?섍린
                          </Button>
                        ) : (
                          ""
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                  {openDetailsFor === std.userId._id && (
                    <PreviousAssignmentsRow assignments={std.assignment} />
                  )}
                </>
              ))}
            </TableBody>
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <TextareaAutosize
                aria-label="improvement text"
                minRows={3}
                style={{ width: "800px" }}
                value={popoverContent}
                onChange={(e) => setPopoverContent(e.target.value)}
              />
            </Popover>
          </Table>
        </TableContainer>
        <AdminAssignmentSubmitDialog
          open={openAssignmentDialog}
          onClose={() => setOpenAssignmentDialog(false)}
          currentAssignment={selectedAgenda}
          studentId={selectedUserId}
        />
      </Box>
    </div>
  );
};

export default DetailAssignments;